module.exports = __webpack_public_path__ + "static/img/layout-2.5afd4b42.jpg";